<template>
	<div v-if="loggedIn"
		class="AppDownloadBanner bg-black px-gr-6 text-white text-xs leading-gr-5 overflow-hidden"
		:class="{ 'duration-500': animate }"
		:style="{ transform, maxHeight }">
		<div class="sm:flex items-center justify-center">
			<div class="font-bold leading-gr-5 text-center mx-gr-5 pt-gr-half-6 sm:py-gr-half-6">Listen on the <br class="hidden sm:block">ONE Audiobooks App</div>
			<div class="flex items-center justify-center space-x-gr-1">
				<a class="font-bold"
					href="https://apps.apple.com/us/app/one-audiobooks/id1664853895?itsct=apps_box_badge&amp;itscg=30200">
					<img class="max-h-gr-8"
						src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1689033600"
						alt="Download on the App Store">
				</a>
				<a class="font-bold"
					href='https://play.google.com/store/apps/details?id=app.oneaudiobooks.library&utm_source=website&utm_campaign=general&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
					<img class="max-h-gr-8" alt='Get it on Google Play'
						src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png' />
				</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'AppDownloadBanner',
	data() {
		return {
			transform: 'translateY(-100%)',
			maxHeight: '0',
			loggedIn: false,
			animate: false,
		};
	},
	mounted() {
		// Animate on promos page
		this.animate = this.$page?.component == 'Listen/Promo';

		// Check if logged in
		this.loggedIn = !!this.$page?.props?.user;
		
		let delay = this.animate ? 1000 : 0;
		setTimeout(() => {
			this.transform = 'translateY(0)';
			this.maxHeight = 'var(--golden-ratio-10)';
		}, delay);
	},
};
</script>

<!-- <style scoped></style> -->
